import { createContext, PropsWithChildren, useContext } from 'react';
import { GHubThemeType } from '../../modules/theme';
import { FeatureFlags } from '../../types/env/FeatureFlags.type';

type ConfigContextValue = Record<string, unknown> & {
	theme: GHubThemeType;
	featureFlags?: FeatureFlags;
};

const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);
ConfigContext.displayName = 'Config Context';

export const ConfigProvider = ({
	children,
	value
}: PropsWithChildren<{ value: ConfigContextValue }>) => {
	return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
	const context = useContext(ConfigContext);

	if (!context) {
		throw new Error('Cannot use config outside of a Config Context Provider');
	}

	return context;
};

export const useOptionalConfig = () => {
	return useContext(ConfigContext);
};
